import React from 'react';
import { useSelector } from 'react-redux';

import { Row, Col } from 'antd';

import { RootState } from '../../../../../../application/store';
import { CustomerSummary } from '../../../../../../api-client';

import './bv-customers-group-item.scss';

interface IBVCustomersGroupItem {
    customer: CustomerSummary;
    showEventFilter: boolean;
    onClick: (customer: CustomerSummary) => void;
}

const BVCustomersGroupItem: React.FunctionComponent<IBVCustomersGroupItem> = ({ customer, showEventFilter, onClick }) => {
    const bvCustomer = useSelector((state: RootState) => state.customer);
    return (
        <div className={`bv-customers-group-item-container ${customer.id === bvCustomer.id && 'bv-customers-group-active'}`} onClick={() => onClick(customer)}>
            <Row gutter={[12, 0]}>
                <Col span={2}>
                    {!showEventFilter && (
                        <span className="customer-heading italic">{customer.draftOrder !== 0 ? customer.draftOrder : ""}</span>
                    )}
                </Col>
                <Col span={16}>
                    <span className="customer-heading">{customer.fullName}</span>
                </Col>
                <Col span={6} style={{ textAlign: 'right' }}>
                    <span className="customer-heading">{customer.sapCode}</span>
                </Col>
            </Row>
        </div>
    );
}

export default BVCustomersGroupItem;